// extracted by mini-css-extract-plugin
export default {"cls1":"QXOVOKmtRbiYQcOa9MWg","cls2":"syx2swdthYF5GO6qVfTi QXOVOKmtRbiYQcOa9MWg"};